import { Identifier, randomUUID } from "../core";
export class POrderLineId extends Identifier {
    constructor() {
        super("POrderLineId", randomUUID());
    }
}
